import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideNav from "./sideNav";
import TopNav from "./topNav";
import StatusBar from "./statusBar";
import { TaskCenterProvider } from "./TaskCenterContext";
import { WarehouseProvider } from "./WarehouseContext";

/* Caliper app shell: full-height sidebar + (topbar / content / statusbar).
   TaskCenterProvider wraps the shell so long-running jobs (report exports)
   keep running across navigation and surface in the topbar bell.
   WarehouseProvider holds the one active-store selection every screen reads, so
   switching store in the topbar re-scopes the whole app at once. */
const CommonLayout = () => {
  /* below lg the sidebar is an off-canvas drawer toggled from the topbar */
  const [navOpen, setNavOpen] = useState(false);
  return (
    <TaskCenterProvider>
      <WarehouseProvider>
        <div className="flex h-screen bg-canvas overflow-hidden">
          <SideNav open={navOpen} onClose={() => setNavOpen(false)} />
          <div className="flex-1 flex flex-col min-w-0">
            <TopNav onMenu={() => setNavOpen(true)} />
            <main className="flex-1 overflow-auto cb-scroll bg-canvas p-3 sm:p-5">
              <Outlet />
            </main>
            <StatusBar />
          </div>
        </div>
      </WarehouseProvider>
    </TaskCenterProvider>
  );
};

export default CommonLayout;
